// src/actions/EntidadActions.js
import apiClient from '../api/apiClient';
// import HttpClient from '../services/HttpClient';
import axios from 'axios';

const instancia = axios.create();
instancia.CancelToken = axios.CancelToken;
instancia.isCancel = axios.isCancel;

export const obtenerEntidadPorId = (id) => {
    return new Promise((resolve, reject) => {
        apiClient.get(`/entidades/${id}`)
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            console.log("error del api entidad por id:", error);
            reject({
                message: error.message,
                response: error.response || null,
                code: error.code || 'UNKNOWN_ERROR'
            });
        });
    });
}

export const obtenerEntidades = () => {
    return new Promise((resolve, reject) => {
        //instancia.get("/api/entidades")
        apiClient.get("/entidades")
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            console.log("error del api entidades:", error);
            reject({
                message: error.message,
                response: error.response || null,
                code: error.code || 'UNKNOWN_ERROR'
            });
        });
    });
}

export const obtenerTiposEntidad = () => {
    return new Promise((resolve, reject) => {
        apiClient.get("/tiposentidad")
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            console.log("error del api tipos entidad:", error);
            reject({
                message: error.message,
                response: error.response || null,
                code: error.code || 'UNKNOWN_ERROR'
            });
        });
    });
}

export const obtenerTiposDocumentoIdentidad = () => {
    return new Promise((resolve, reject) => {
        apiClient.get("/tiposdocumentoidentidad")
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            console.log("error del api tipos documento identidad:", error);
            reject({
                message: error.message,
                response: error.response || null,
                code: error.code || 'UNKNOWN_ERROR'
            });
        });
    });
}

export const obtenerMunicipios = () => {
    return new Promise((resolve, reject) => {
        apiClient.get("/municipios/all")
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            console.log("error del api municipios:", error);
            reject({
                message: error.message,
                response: error.response || null,
                code: error.code || 'UNKNOWN_ERROR'
            });
        });
    });
}

export const crearEntidad = async (entidadData) => {
    try {
        const response = await apiClient.post("/entidades", entidadData);
        return response;
    } catch (error) {
        console.error('Error en crearEntidad:', error);
        if (error.response) {
            return error.response;
        } else if (error.request) {
            return {
                status: 503,
                data: { message: "No se pudo conectar al servidor" }
            };
        } else {
            return {
                status: 500,
                data: { message: error.message || "Error al crear la entidad" }
            };
        }
    }
}

export const actualizarEntidad = async (id, entidadData) => {
    try {
        const response = await apiClient.put(`/entidades/${id}`, entidadData);
        return response;
    } catch (error) {
        console.error('Error en actualizarEntidad:', error);
        if (error.response) {
            return error.response;
        } else if (error.request) {
            return {
                status: 503,
                data: { message: "No se pudo conectar al servidor" }
            };
        } else {
            return {
                status: 500,
                data: { message: error.message || "Error al actualizar la entidad" }
            };
        }
    }
} 

// En src/actions/EntidadAction.js
export const obtenerDepartamentos = async () => {
  try {
    const response = await apiClient.get('/departamentos/all');
    return response;
  } catch (error) {
    console.error('Error obteniendo departamentos:', error);
    throw error;
  }
};